module.exports = "/_next/static/images/slide8-61e7c778b28ea1819a85f27e28be5558.webp";